import React, { useState, useEffect, useRef } from "react";
import classes from "./Footer.module.scss";
import logo from "../../../assets/img/costcall/header/logo.png";
import img1 from "../../../assets/img/costcall/header/telegram.png";

import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  //const [localA, setLocalA] = useState(false);
  const [burgerA, setBurgerA] = useState(false);

  useEffect(() => {
    console.log("Hi");
    const body = document.querySelector("body");
    if (burgerA) {
      body.classList.add("lock");
    } else {
      body.classList.remove("lock");
    }
  }, [burgerA])

  return (
    <div className={classes.header}>
      <div className={classes.headerBody}>
        <div className="container">
          <div className={classes.headerRow}>
            <a href="/costcall" className={[classes.headerRowLogo, ""].join(" ")}>
              <img src={logo} alt="logo" />
            </a>
            <div className={[classes.headerRowNav, ""].join(" ")}>
              <a href="#" className={[classes.headerRowNavItem, ""].join(" ")}>
                О нас
              </a>
              <a href="#" className={[classes.headerRowNavItem, ""].join(" ")}>
                Сервера
              </a>
              <a href="#" className={[classes.headerRowNavItem, ""].join(" ")}>
                Устройства
              </a>
              <a href="#" className={[classes.headerRowNavItem, ""].join(" ")}>
                Безопасность
              </a>
              <a href="#" className={[classes.headerRowNavItem, ""].join(" ")}>
                FAQ
              </a>
            </div>
            <a href="#" className={[classes.headerRowButton, ""].join(" ")}>
              <span>Связаться</span>
              <span><img src={img1} alt="telegram" /></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
